/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientMetricEvent
 */
export interface ClientMetricEvent {
    /**
     * 
     * @type {string}
     * @memberof ClientMetricEvent
     */
    event: ClientMetricEventEventEnum;
    /**
     * 
     * @type {string}
     * @memberof ClientMetricEvent
     */
    platform: ClientMetricEventPlatformEnum;
    /**
     * 
     * @type {string}
     * @memberof ClientMetricEvent
     */
    route: ClientMetricEventRouteEnum;
    /**
     * 
     * @type {string}
     * @memberof ClientMetricEvent
     */
    outcome?: ClientMetricEventOutcomeEnum;
}


/**
 * @export
 */
export const ClientMetricEventEventEnum = {
    HotelReviewsRequested: 'hotel_reviews_requested',
    HotelReviewsSucceeded: 'hotel_reviews_succeeded',
    HotelReviewsFailed: 'hotel_reviews_failed',
    GooglePlacesAutocompleteRequested: 'google_places_autocomplete_requested',
    GooglePlacesAutocompleteSucceeded: 'google_places_autocomplete_succeeded',
    GooglePlacesAutocompleteFailed: 'google_places_autocomplete_failed',
    GooglePlacesDetailsRequested: 'google_places_details_requested',
    GooglePlacesDetailsSucceeded: 'google_places_details_succeeded',
    GooglePlacesDetailsFailed: 'google_places_details_failed'
} as const;
export type ClientMetricEventEventEnum = typeof ClientMetricEventEventEnum[keyof typeof ClientMetricEventEventEnum];

/**
 * @export
 */
export const ClientMetricEventPlatformEnum = {
    Web: 'web',
    Mobile: 'mobile'
} as const;
export type ClientMetricEventPlatformEnum = typeof ClientMetricEventPlatformEnum[keyof typeof ClientMetricEventPlatformEnum];

/**
 * @export
 */
export const ClientMetricEventRouteEnum = {
    HotelDetails: 'hotel_details',
    HotelSearch: 'hotel_search',
    AddressEntry: 'address_entry',
    VehicleSearch: 'vehicle_search',
    AddHotel: 'add_hotel',
    SharedPlaces: 'shared_places'
} as const;
export type ClientMetricEventRouteEnum = typeof ClientMetricEventRouteEnum[keyof typeof ClientMetricEventRouteEnum];

/**
 * @export
 */
export const ClientMetricEventOutcomeEnum = {
    Requested: 'requested',
    Success: 'success',
    Error: 'error'
} as const;
export type ClientMetricEventOutcomeEnum = typeof ClientMetricEventOutcomeEnum[keyof typeof ClientMetricEventOutcomeEnum];


/**
 * Check if a given object implements the ClientMetricEvent interface.
 */
export function instanceOfClientMetricEvent(value: object): value is ClientMetricEvent {
    if (!('event' in value) || value['event'] === undefined) return false;
    if (!('platform' in value) || value['platform'] === undefined) return false;
    if (!('route' in value) || value['route'] === undefined) return false;
    return true;
}

export function ClientMetricEventFromJSON(json: any): ClientMetricEvent {
    return ClientMetricEventFromJSONTyped(json, false);
}

export function ClientMetricEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientMetricEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'event': json['event'],
        'platform': json['platform'],
        'route': json['route'],
        'outcome': json['outcome'] == null ? undefined : json['outcome'],
    };
}

export function ClientMetricEventToJSON(json: any): ClientMetricEvent {
    return ClientMetricEventToJSONTyped(json, false);
}

export function ClientMetricEventToJSONTyped(value?: ClientMetricEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'event': value['event'],
        'platform': value['platform'],
        'route': value['route'],
        'outcome': value['outcome'],
    };
}

